'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.refineLayoutSize = exports.truncateHeader = exports.truncateSectionRows = exports.refineHeader = exports.refineSections = exports.getCuratedCells = undefined;
var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');
var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
var _defineProperty2 = require('babel-runtime/helpers/defineProperty');
var _defineProperty3 = _interopRequireDefault(_defineProperty2);
var _extends3 = require('babel-runtime/helpers/extends');
var _extends4 = _interopRequireDefault(_extends3);
var _set = require('babel-runtime/core-js/set');
var _set2 = _interopRequireDefault(_set);
var _ramda = require('ramda');
var R = _interopRequireWildcard(_ramda);
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var toKey = function toKey(indexes) {
  return R.reduce(function (acc, _ind) {
    var ind = R.is(Array, _ind) ? toKey(_ind) : String(Math.abs(_ind));
    if (R.isEmpty(ind)) {
      return acc;
    }
    return R.isEmpty(acc) ? ind : acc + ':' + ind;
  }, '', indexes);
};
var getPivotKey = function getPivotKey(indexes) {
  return R.pipe(R.props(indexes), R.join(':'));
};
var getPivots = function getPivots(layout, shape) {
  return R.pipe(R.props(shape), R.map(R.pipe(R.map(function (entry) {
    return R.has('dimensions', entry) ? R.pluck('__index', entry.dimensions || []) : entry.__index;
  }), R.unnest, getPivotKey)))(layout);
};
var indexWithPivots = function indexWithPivots(pivots, observations) {
  return R.pipe(R.values, R.reduce(function (acc, obs) {
    var path = R.map(function (pivot) {
      return pivot(obs.orderedDimIndexes);
    }, pivots);
    return R.over(R.lensPath(path), R.ifElse(R.isNil, R.always([obs]), R.append(obs)))(acc);
  }, {}))(observations);
};
var getCuratedCells = exports.getCuratedCells = function getCuratedCells(_ref) {
  var layout = _ref.layout,
    observations = _ref.observations,
    shape = _ref.shape;
  var pivots = getPivots(layout, shape);
  return indexWithPivots(pivots, observations);
};
var filterSeries = function filterSeries(series, getHasStillData) {
  var removedMissingIndexes = [];
  return R.reduce(function (acc, serie) {
    var hasStillData = getHasStillData(serie);
    var serieParentsSets = R.map(function (p) {
      return new _set2.default(p);
    }, R.propOr([], 'parentsIndexes', serie));
    if (!hasStillData) {
      removedMissingIndexes = R.addIndex(R.map)(function (mIs, ind) {
        var filtered = R.filter(function (i) {
          return serieParentsSets[ind].has(i);
        }, R.nth(ind, removedMissingIndexes) || []);
        return R.concat(filtered, mIs);
      }, serie.missingIndexes || []);
      return acc;
    }
    var _serie = R.pipe(R.over(R.lensProp('missingIndexes'), function () {
      var missingIndexes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return R.addIndex(R.map)(function (mIs, ind) {
        var removed = R.nth(ind, removedMissingIndexes) || [];
        if (R.isEmpty(removed)) {
          return mIs;
        }
        var filteredRemoved = R.filter(function (i) {
          return serieParentsSets[ind].has(i);
        }, removed);
        return R.concat(filteredRemoved, mIs || []);
      }, missingIndexes);
    }), R.over(R.lensProp('parentsIndexes'), function () {
      var parentsIndexes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return R.addIndex(R.map)(function (p, ind) {
        return R.reject(function (i) {
          return R.includes(i, R.nth(ind, removedMissingIndexes) || []);
        }, p || []);
      }, parentsIndexes);
    }))(serie);
    removedMissingIndexes = [];
    return R.append(_serie, acc);
  }, [], series);
};
var refineSections = exports.refineSections = function refineSections(sections, extractedKeys, curatedObs) {
  return R.pipe(R.map(function (section) {
    var sectionKey = toKey(R.propOr([], 'indexes', R.head(section)));
    var getHasRowStillData = function getHasRowStillData(row) {
      var rowKey = toKey(R.prop('indexes', row));
      return R.pipe(R.path([sectionKey, rowKey]), R.omit(extractedKeys), R.isEmpty, R.not)(curatedObs);
    };
    return R.over(R.lensIndex(1), function (rows) {
      return filterSeries(rows, getHasRowStillData);
    })(section);
  }), R.filter(R.pipe(R.nth(1), R.isEmpty, R.not)))(sections);
};
var refineHeader = exports.refineHeader = function refineHeader(headers, extractedKeys, curatedObs) {
  var getHasHeaderStillData = function getHasHeaderStillData(header) {
    var headerKey = toKey(R.prop('indexes', header));
    return R.pipe(R.prop(headerKey), function (sections) {
      return R.pickBy(function (rows, section) {
        return R.pipe(R.omit(R.propOr([], section, extractedKeys)), R.isEmpty, R.not)(rows);
      }, sections);
    }, R.isEmpty, R.not)(curatedObs);
  };
  return filterSeries(headers, getHasHeaderStillData);
};
var getSerieLinesCount = function getSerieLinesCount(serie) {
  var missingParents = R.propOr([], 'missingParents', serie);
  var missingParentsRowsCount = R.pipe(R.flatten, R.length)(missingParents);
  return missingParentsRowsCount + 1;
};
var truncateSectionRows = exports.truncateSectionRows = function truncateSectionRows(n, sectionsData) {
  var truncated = sectionsData;
  var extractedKeys = {};
  var _n = n;
  while (_n > 0) {
    var lastSection = R.last(truncated);
    var rows = lastSection[1];
    var rowsLength = R.length(rows);
    var truncatedRowsCount = 0;
    while (_n > 0 && truncatedRowsCount !== rowsLength) {
      var rowsCount = getSerieLinesCount(R.nth(-1 * truncatedRowsCount, rows));
      _n = _n - rowsCount;
      truncatedRowsCount++;
    }
    var sectionKey = R.pipe(R.head, R.prop('indexes'), toKey)(lastSection);
    extractedKeys = (0, _extends4.default)({}, extractedKeys, (0, _defineProperty3.default)({}, sectionKey, R.pipe(R.takeLast(truncatedRowsCount), R.map(function (r) {
      return toKey(R.prop('indexes', r));
    }))(rows)));
    if (_n > 0) {
      truncated = R.dropLast(1, truncated);
    } else {
      truncated = R.over(R.lensIndex(-1), R.over(R.lensIndex(1), R.dropLast(truncatedRowsCount)))(truncated);
    }
  }
  return {
    truncated: truncated,
    extractedKeys: extractedKeys
  };
};
var truncateHeader = exports.truncateHeader = function truncateHeader(n, headerData) {
  var _truncated$extractedK = {
      truncated: headerData,
      extractedKeys: []
    },
    truncated = _truncated$extractedK.truncated,
    extractedKeys = _truncated$extractedK.extractedKeys;
  var _n = n;
  while (_n > 0) {
    var lastHeader = R.last(truncated);
    var columnsCount = getSerieLinesCount(lastHeader);
    var extractedKey = toKey(R.prop('indexes', lastHeader));
    extractedKeys = R.append(extractedKey, extractedKeys);
    truncated = R.dropLast(1, truncated);
    _n = _n - columnsCount;
  }
  return {
    truncated: truncated,
    extractedKeys: extractedKeys
  };
};
var truncateLayout = function truncateLayout(isVertical) {
  return R.ifElse(R.always(isVertical), truncateSectionRows, truncateHeader);
};
var refineLayout = function refineLayout(isVertical) {
  return R.ifElse(R.always(isVertical), refineHeader, refineSections);
};
var getShape = function getShape(isVertical) {
  return isVertical ? ['header', 'sections', 'rows'] : ['sections', 'rows', 'header'];
};
var getRefinedLayout = function getRefinedLayout(isVertical, truncated, refined) {
  return R.ifElse(R.always(isVertical), R.pipe(R.assoc('sections', truncated), R.assoc('header', refined)), R.pipe(R.assoc('header', truncated), R.assoc('sections', refined)))({});
};
var segregateLayout = function segregateLayout(isVertical) {
  return R.ifElse(R.always(isVertical), R.props(['sections', 'header']), R.props(['header', 'sections']));
};
var refineLayoutSize = exports.refineLayoutSize = function refineLayoutSize(_ref2) {
  var layout = _ref2.layout,
    observations = _ref2.observations,
    limit = _ref2.limit;
  return function (layoutIndexes) {
    var header = layoutIndexes.header,
      sections = layoutIndexes.sections;
    if (R.isNil(limit) || limit === 0 || R.all(R.isEmpty, [header, sections])) {
      return R.pipe(R.set(R.lensProp('truncated'), false), R.set(R.lensProp('totalCells'), null))(layoutIndexes);
    }

    //number of dimensions in header
    var headerDimCount = R.pipe(R.head,
    // first column
    R.when(R.isNil, R.always({})), R.propOr([], 'indexes'), R.length // number of dims
    )(header);

    //number of columns for values
    var headerValuesCount = R.pipe(R.reduce(function (acc, header) {
      var columnsCount = getSerieLinesCount(header);
      return acc + columnsCount;
    }, 0), R.when(R.equals(0), R.always(1)))(header);

    //total of cells in header
    var headerCellsCount = headerDimCount * (headerValuesCount + 1);

    // number of dimensions in a row
    var rowDimCount = R.pipe(R.head,
    // firstSection
    R.last,
    // rows,
    R.head,
    // first row
    R.propOr([], 'indexes'), R.length)(sections);

    // number of cells in a row
    var rowCellsCount = rowDimCount + headerValuesCount + 1;

    // number of rows
    var rowsCount = R.pipe(R.map(R.last), R.unnest, R.reduce(function (acc, row) {
      var rowsCount = getSerieLinesCount(row);
      return acc + rowsCount;
    }, 1))(sections);

    // total of cells in all rows
    var rowsCellsCount = rowCellsCount * rowsCount;

    // number of sections cells
    var sectionsCellsCount = R.ifElse(R.pipe(R.head, R.head, R.propOr([], 'indexes'), R.length, R.equals(0)), R.always(0), R.length)(sections);
    var total = rowsCellsCount + sectionsCellsCount + headerCellsCount;
    var excess = total - limit;
    if (excess <= 0) {
      return R.pipe(R.set(R.lensProp('truncated'), false), R.set(R.lensProp('totalCells'), total))(layoutIndexes);
    }

    // total of cells in one column
    var columnCellsCount = headerDimCount + rowsCount;
    var isVertical = columnCellsCount > rowCellsCount;
    var _segregateLayout = segregateLayout(isVertical)(layoutIndexes),
      _segregateLayout2 = (0, _slicedToArray3.default)(_segregateLayout, 2),
      toTruncate = _segregateLayout2[0],
      toRefine = _segregateLayout2[1];
    var cutLength = R.pipe(R.ifElse(R.identity, R.always(rowCellsCount), R.always(columnCellsCount)), R.divide(excess), Math.ceil)(isVertical);
    var maxCutLength = isVertical ? rowsCount - 2 : headerValuesCount - 1;
    cutLength = cutLength > maxCutLength ? maxCutLength : cutLength;
    var _truncateLayout = truncateLayout(isVertical)(cutLength, toTruncate),
      truncated = _truncateLayout.truncated,
      extractedKeys = _truncateLayout.extractedKeys;
    var dimsLength = R.pipe(R.values, R.head, R.propOr([], 'orderedDimIndexes'), R.length)(observations);
    var _layout = R.map(R.map(function (entry) {
      return entry.id === 'OBS_ATTRIBUTES' ? R.assoc('__index', dimsLength - 1, entry) : entry;
    }), layout);
    var curatedObs = R.pipe(getShape, function (shape) {
      return getCuratedCells({
        layout: _layout,
        observations: observations,
        shape: shape
      });
    })(isVertical);
    var refined = refineLayout(isVertical)(toRefine, extractedKeys, curatedObs);
    var result = getRefinedLayout(isVertical, truncated, refined);
    return R.pipe(R.set(R.lensProp('truncated'), true), R.set(R.lensProp('totalCells'), total))(result);
  };
};